module.exports = __webpack_public_path__ + "img/close-rit.282b8d82.svg";